<template>
  <RedesignSearchDestinationSelectMobile
    v-if="$screen.isSmall"
    v-model="model"
    class="w-full"
  />

  <RedesignSearchDestinationSelectDesktop
    v-else
    v-model="model"
    class="w-full md:max-w-72"
  />
</template>

<script setup lang="ts">
import type { SuggestionOption } from '~/composables/useDestinationSearch'

const model = defineModel<SuggestionOption | undefined>()
</script>
